import { CCol, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCall, apiCallResponse } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import {
  FilterEqual,
  FilterContainsInsensitive,
} from "../common/FilterCondition";
import { CommonSearch, updateSearchStatus } from "../common/CommonSearch";

const PendingAgreementextendListHO = () => {
  const { authenticated } = Auth();
  const [pendingagrementextend, setpendingagrementextend] = useState();
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading

  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10);
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  // Your default search model
  const SearchFilterModel = {
    collectionSeason: new Date().getFullYear().toString(),
    tenderNo: "",
    companyName: "",
    emailAddress: "",
    lotNo: "",
  };

  const [search, setSearch] = useState(SearchFilterModel);

  // useEffect(() => {
  //   getList();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [authenticated]);

  useEffect(() => {
    setloading(true);
    reset();
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, itemPerPage]);
  //textField, orderClick,

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getList(true);
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const reset = () => {
    setpageLimit(0);
  };
  const approve = async (lotid, paymentid) => {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "LotDetails/ApporveRejectAgreementExtend",
      "POST",
      header,
      JSON.stringify({
        isApprove: true,
        lotId: lotid,
        userId: authenticated.userId,
        paymentId: paymentid,
      })
    );

    await response.json();
    if (response.status === 200) {
      alert("Extention Approved Successfully.");
      getList();
    }
  };

  const reject = async (lotid, paymentid) => {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "LotDetails/ApporveRejectAgreementExtend",
      "POST",
      header,
      JSON.stringify({
        isApprove: false,
        lotId: lotid,
        userId: authenticated.userId,
        paymentId: paymentid,
      })
    );

    await response.json();
    if (response.status === 200) {
      alert("Extention Reject Successfully.");
      getList();
    }
  };

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";

    filter = FilterEqual(filter, "collectionSeason", search.collectionSeason);
    filter = FilterEqual(filter, "tender", search.tenderNo);

    filter = FilterContainsInsensitive(
      filter,
      "companyName",
      search.companyName
    );
    filter = FilterContainsInsensitive(
      filter,
      "emailAddress",
      search.emailAddress
    );
    filter = FilterContainsInsensitive(filter, "lotNumber", search.lotNo);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(
        `LotDetails/GetPendingAgreementExtendForHO?${filterManage()}`
      ).then((res) => {
        if (res.success) paggingDisabledManage(parseInt(res.data.length) || 0);
      });
    }
  };

  const getList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);
      //
      await apiCallResponse(
        `LotDetails/GetPendingAgreementExtendForHO?$orderBy=emailAddress%20asc&$skip=${pageLimit}&$top=${parseInt(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          setpendingagrementextend(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingDisabledManage(pageCount);
          }
        }
        setloading(false);
      });
    }
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setpendingagrementextend();
  };

  let fields = [
    {
      key: "emailAddress",
      _style: { width: "6%" },
      label: <div>Email Address</div>,
    },
    {
      key: "companyName",
      _style: { width: "6%" },
      label: <div>Company Name</div>,
    },
    {
      key: "lotNumber",
      _style: { width: "15%" },
      label: <div>Lot Number</div>,
    },
    {
      key: "tender",
      _style: { width: "15%" },
      label: <div>Tender</div>,
    },
    {
      key: "payFor",
      _style: { width: "15%" },
      label: <div>PayFor</div>,
    },
    {
      key: "paymentDate",
      _style: { width: "15%" },
      label: <div>Payment Date</div>,
    },
    {
      key: "approveExtendAgreement",
      label: "Approve",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "rejectExtendAgreement",
      label: "Reject",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];
  //Search Filter Manage ( UI also)
  const additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isCompanyNameDisplay={true}
      isEmailAddressDisplay={true}
      isLotNumberDisplay={true}
    />
  );
  return (
    <>
      <CRow>
        <CCol xl={12}>
          <CommonList
            items={pendingagrementextend}
            fields={fields}
            listName="Pending Agreement Extend List"
            loading={loading}
            additional={additional}
            prev={prevButton}
            next={nextButton}
            disabledprev={disabledprev}
            disablednext={disablednext}
            approved={approve}
            reject={reject}
          />
        </CCol>
      </CRow>
    </>
  );
};
export default PendingAgreementextendListHO;
